import cn from 'classnames';
import { ReactNode } from 'react';
import { useSpring, animated } from 'react-spring';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import { formatThousandNumber } from '@utils/utils';
import styles from './stat-card.module.scss';

interface IProps {
    children?: ReactNode;
    name: string;
    value: number;
    position?: 'left' | 'center';
    withCoinIcon?: boolean;
    percentage?: boolean;
    className?: string;
}

const StatCard = ({
    children,
    name,
    value,
    percentage = false,
    position = 'center',
    withCoinIcon = false,
    className = '',
}: IProps): JSX.Element => {
    /* Animations */

    const valueSpring = useSpring({
        from: {
            opacity: 0,
            transform: 'translateY(20px)',
        },
        to: {
            opacity: 1,
            transform: 'translateY(0px)',
        },
        reset: true,
    });

    const valueStyles = percentage
        ? { ...valueSpring, color: value > 50 ? '#4FFF8B' : '#f15151' }
        : { ...valueSpring };

    /* ClassNames */

    const statClasses: string = cn(styles['stat-card'], className, {
        [styles[`stat-card-position-${position}`]]: position,
    });

    return (
        <div className={statClasses}>
            <section className={styles.stat}>
                <h3>{name}</h3>

                <animated.p style={valueStyles}>
                    {withCoinIcon && <CoinIcon />}

                    <span>
                        {!percentage
                            ? formatThousandNumber(value)
                            : `${value}%`}
                    </span>
                </animated.p>
            </section>
            {children}
        </div>
    );
};

export default StatCard;
